<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466824430_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>This book owes a large debt to my late husband, Charles Sheffield, who allowed me to use the McAndrew Drive he created for his own character, Arthur Morton McAndrew.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>I would also like to thank my editor, Jim Minz, for his many valuable contributions.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466824430_ack01.vue?31552ea3